export default __webpack_public_path__ + "static/uol-27b13157c43f9410fa7bdc0faa278388.webp";